module.exports = __webpack_public_path__ + "static/media/duty_cycles.71ca5e8f.png";